__turbopack_context__.v({
  "label": "FormTextArea-module-scss-module__KqyZHW__label",
  "text-area": "FormTextArea-module-scss-module__KqyZHW__text-area",
  "text-area-container": "FormTextArea-module-scss-module__KqyZHW__text-area-container",
  "text-area-error": "FormTextArea-module-scss-module__KqyZHW__text-area-error",
});
